import { useEffect, useState } from 'react';
import { Tabs, Tab, Box, Button,Checkbox,
  FormControlLabel, Select,
  MenuItem,
  InputLabel,
  FormControl,
  TextField} from '@mui/material';
import { useNavigate } from 'react-router-dom';


function Greetings({ onNext }) {
  const [greetCustomer, setGreetCustomer] = useState(false);
  const [numCustomers, setNumCustomers] = useState('');

  const handleCheckboxChange = (event) => {
    setGreetCustomer(event.target.checked);
  };

  const handleInputChange = (event) => {
    setNumCustomers(event.target.value);
  };

  return (
    <div>
      <h3>Greetings</h3>

      <FormControlLabel
        control={
          <Checkbox
            checked={greetCustomer}
            onChange={handleCheckboxChange}
          />
        }
        label="Welcome the Customer/Customers"
      />

      <Box mt={2}>
        <TextField
          label="Number of customers"
          type="number"
          value={numCustomers}
          onChange={handleInputChange}
          InputProps={{ inputProps: { min: 1 } }}
        />
      </Box>

      <Box mt={2}>
        <Button variant="contained" onClick={onNext}>Next</Button>
      </Box>
    </div>
  );
}

function TableAssignments({ onNext }) {
  const [tableNumber, setTableNumber] = useState('');

  const handleChange = (event) => {
    setTableNumber(event.target.value);
  };

  // Example list of available table numbers
  const availableTables = [1, 2, 3, 4, 5, 6];

  return (
    <div>
      <h3>Table Assignments</h3>

      <p>Lead the Customers to the Table.</p>

      <h4>Assign Table</h4>

      <Box mt={2}>
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel id="table-number-label">Table Number</InputLabel>
          <Select
            labelId="table-number-label"
            value={tableNumber}
            label="Table Number"
            onChange={handleChange}
          >
            {availableTables.map((table) => (
              <MenuItem key={table} value={table}>
                Table {table}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Box mt={2}>
        <Button
          variant="contained"
          onClick={onNext}
          disabled={!tableNumber} // disable Next if not selected
        >
          Next
        </Button>
      </Box>
    </div>
  );
}


function Portal() {
  const navigate = useNavigate();
  const [tab, setTab] = useState(0);

  // Redirect to login if not logged in
  useEffect(() => {
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    if (!isLoggedIn) {
      navigate('/');
    }
  }, [navigate]);

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  const handleNext = () => {
    if (tab < 4) {
      setTab(prev => prev + 1);
    }
  };

  const handleOpenMenu = () => {
    alert('Functionality to be added soon...');
  };

  return (
    <Box sx={{ width: '100%', padding: 3 }}>
      <div style={{ padding: '20px' }}>
        <h2>Portal</h2>
        <p>POS Portal.</p>
      </div>

      <Tabs value={tab} onChange={handleChange} textColor="primary" indicatorColor="primary" variant="scrollable" scrollButtons="auto">
        <Tab label="Greetings" />
        <Tab label="Table Assignments" />
        <Tab label="Order Details" />
        <Tab label="Order Summary" />
        <Tab label="Payment Interface" />
      </Tabs>

      <Box sx={{ mt: 2 }}>
        {tab === 0 && <Greetings onNext={handleNext} />}
        {tab === 1 && <TableAssignments onNext={handleNext} />}
        {tab === 2 && <OrderDetails onNext={handleNext} handleOpenMenu={handleOpenMenu}/>}
        {tab === 3 && <OrderSummary onNext={handleNext} />}
        {tab === 4 && <PaymentInterface />}
      </Box>
    </Box>
  );
}





function OrderDetails({ onNext, handleOpenMenu }) {
  return (
    <div>
      <h3>Order Details</h3>
      <Button  onClick={handleOpenMenu} sx={{ float: 'center' }}>Add Items</Button>
      {/* float right */}
      <br></br>
      <br></br>
      <Button variant="contained" onClick={onNext}>Complete order</Button>
    </div>
  );
}

function OrderSummary({ onNext }) {
  return (
    <div>
      <h3>Order Summary</h3>
      <Button variant="contained" onClick={onNext}>Proceed to Payment</Button>
    </div>
  );
}

function PaymentInterface() {
  return <div><h3>Payment Interface</h3></div>;
}

export default Portal;
